module.exports = __webpack_public_path__ + "static/img/bannerpay.c262c67.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/bannerpay.jpg
// module id = JNAF
// module chunks = 1